import React from 'react';
import { shiftSummaryDashboardToRevisit } from "./FatigueAssessmentPageSelector";
import { FatigueAssessmentView } from './FatigueAssessmentView';
import FatigueAssessmentDashboard from "./FatigueAssessmentDashboard";

const FatigueAssessmentDashboardToRevisit = () => {
    return (
        <FatigueAssessmentDashboard
            page={shiftSummaryDashboardToRevisit}
            pageView={FatigueAssessmentView.ToRevisit}
        />
    );
}

export default FatigueAssessmentDashboardToRevisit;
